var map = {
	"./bci-1-hover.svg": 756,
	"./bci-1.svg": 2239,
	"./bci-10-hover.svg": 757,
	"./bci-10.svg": 2240,
	"./bci-11-hover.svg": 758,
	"./bci-11.svg": 2241,
	"./bci-12-hover.svg": 759,
	"./bci-12.svg": 2242,
	"./bci-2-hover.svg": 760,
	"./bci-2.svg": 2243,
	"./bci-3-hover.svg": 761,
	"./bci-3.svg": 2244,
	"./bci-4-hover.svg": 762,
	"./bci-4.svg": 2245,
	"./bci-5-hover.svg": 763,
	"./bci-5.svg": 2246,
	"./bci-7-hover.svg": 764,
	"./bci-7.svg": 2247,
	"./bci-8-hover.svg": 765,
	"./bci-8.svg": 2248
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2238;